import { render, staticRenderFns } from "./covid-19-social.vue?vue&type=template&id=2cab0a10&"
import script from "./covid-19-social.vue?vue&type=script&lang=js&"
export * from "./covid-19-social.vue?vue&type=script&lang=js&"
import style0 from "./covid-19-social.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports